<script setup>

const props = defineProps({
  association: "",
  url: "",
});
</script>

<template>
  <div>
    <p>{{ $t("membersForm.modalText", { association: association }) }}</p>
    <p>
      <a class="text-primary" :href="url" target="_blank" rel="noopener">
        {{ $t("membersForm.modalTextUrl", { association: association }) }}
      </a>
    </p>
  </div>
</template>
